const host = 'http://anxing.zztczg.cn'
export const HOST = host
export const UPLOAD_IMG_UTL = host + '/api/m1361/5d5fa8984f0c2'
export const ALLOWHOOK = {
  video: '.mp4, .ogv, .ogg, .webm',
  audio: '.wav, .mp3, .ogg, .acc, .webm, .amr',
  file: 'doc,.docx,.xlsx,.xls,.pdf',
  excel: 'xlsx,.xls',
  img: '.jpg, .jpeg, .png, .gif'
}